module.exports = __webpack_public_path__ + "img/J11.47b0f956.webp";